export default {
    DEFAULT_PAGE_SIZE: 10,
    API_ROOT: process.env.REACT_APP_COMPLAINTS_API_ROOT,
    API_ROOT_USERS: process.env.REACT_APP_COMPLAINTS_API_ROOT_USERS,
    API_ROOT_SEARCH: process.env.REACT_APP_COMPLAINTS_API_ROOT_SEARCH,
    API_ROOT_REFDATA: process.env.REACT_APP_COMPLAINTS_API_ROOT_REFDATA,
    API_AVATAR_HOST: process.env.REACT_APP_COMPLAINTS_AVATAR_HOST,
    API_ROOT_ORGS: process.env.REACT_APP_API_HOST_ORGS,
    API_HOST_LINKEDRECORDS: process.env.REACT_APP_API_HOST_LINKEDRECORDS,
    API_ROOT_SVR: process.env.REACT_APP_API_HOST_SVR,
};
